import { CdkMenuModule } from "@angular/cdk/menu";
import { booleanAttribute, Component, input, signal } from "@angular/core";
import { NG_VALUE_ACCESSOR } from "@angular/forms";
import { BaseInput } from "../base-input";
import { Input } from "../input.component";
import { InputTimePicker } from "./time-picker/time-picker.component";

@Component({
    selector: "app-input-time",
    templateUrl: "./input-time.component.html",
    standalone: true,
    imports: [Input, InputTimePicker, CdkMenuModule],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: InputTime,
            multi: true,
        },
    ],
})
export class InputTime extends BaseInput<string> {
    wrap = input<boolean, string>(false, { transform: booleanAttribute });
    open = signal(false);
    icon = input<string>();

    pick(time: string) {
        this.value.set(time);
    }

    /**
     * picker를 열기 전에 validation을 수행한다.
     * @param ev
     * @returns
     */
    validate(ev: any) {
        if (this.disabled() || this.readonly()) {
            ev.stopPropagation();
            ev.preventDefault();

            return;
        }
    }

    /**
     * picker를 열어준다.
     */
    handleOpenPicker() {
        this.open.set(true);
    }
}
